<template>
    <div class="hot-specials">
        <div class="hot-specials-container">
            <!-- title -->
            <home-title :title="'热门赛事'" :type="2" :moreUrl="'/special'" />
            <hot-special-item :special="specials[0]" />
        </div>
        <hot-special-item v-for="s in specials.slice(1)" :special="s" :key="s.id" />
    </div>
</template>

<script>
import HomeTitle from './HomeTitle.vue';
import HotSpecialItem from './hot-speciall/hot-special-item.vue';
export default {
    data() {
        return {
            // data: [],
        };
    },
    props: {
        specials: {
            type: Array,
            default() {
                return [{ id: 0 }];
            },
        },
    },

    components: { HomeTitle, HotSpecialItem },

    computed: {
        user() {
            return this.$store.getters.userInfo;
        },
    },

    methods: {
        // async getData() {
        //     const { data } = await this.$axios('getHomeHotCmpt', { type: 2, page: 1, pageSize: 3 });
        //     this.data = data;
        // },

        // 奖金序列化
        toThousands(num) {
            var result = '',
                counter = 0;
            num = (num || 0).toString();
            for (var i = num.length - 1; i >= 0; i--) {
                counter++;
                result = num.charAt(i) + result;
                if (!(counter % 3) && i != 0) {
                    result = ',' + result;
                }
            }
            return result;
        },
        handleClickItem(item) {
            if (item.linkUrl.indexOf('datafountain.cn' > -1)) {
                this.$router.push(item.linkUrl.split('datafountain.cn')[1]);
            } else {
                this.$router.push(item.linkUrl);
            }
        },
    },

    created() {
        // this.getData();
    },
};
</script>

<style lang="scss" scoped>
.hot-specials {
    margin-top: 22px;
    // padding: 0 14px;
    .hot-specials-container {
        width: 724px;
        max-height: 1270px;
        background: #ffffff;
        border-radius: 28px;
        padding-top: 22px;
        margin: 0 14px;
        padding-bottom: 10px;
    }
}
</style>
